import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import HSGraph from "../../components/Graph/HSGraph";
import {useStationQuery, useTimeseriesQuery} from "./query";
import TempGraph from "./TempGraph";
import HNGraph from "./HNGraph";
import HNCumGraph from "./HNCumGraph";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";


const StationGraphs = ({stationId, station}) => {
    const {t} = useTranslation("graphs");

    const timeseriesQuery = useTimeseriesQuery(stationId);
    const stationQuery = useStationQuery(stationId, {enabled: !!stationId});
    station = station ?? stationQuery.data;

    const data = useMemo( () => (
        timeseriesQuery.data ?
            timeseriesQuery.data.timestamps.map((timestamp, index) => {
                return {
                    timestamp: new Date(timestamp),
                    hs: timeseriesQuery.data.hs?.[index],
                    hn: timeseriesQuery.data.hn?.[index],
                    ta: timeseriesQuery.data.ta?.[index],
                    tMin: timeseriesQuery.data.tMin?.[index],
                    tMax: timeseriesQuery.data.tMax?.[index],
                    th10: timeseriesQuery.data.th10?.[index],
                    th30: timeseriesQuery.data.th30?.[index],
                }
            })
            :
            []
    ), [timeseriesQuery.data])

    return <MDBox sx={{width: "100%", maxWidth: "100%", minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>
        <div>
            <MDTypography variant="h5">{t('hsGraph.title')}</MDTypography>
            <HSGraph data={data} station={station?? {}}/>
        </div>
        <div>
            <MDTypography variant="h5">{t('hnGraph.title')}</MDTypography>
            <HNGraph data={data} station={station?? {}}/>
        </div>
        <div>
            <MDTypography variant="h5">{t('hnCumGraph.title')}</MDTypography>
            <HNCumGraph data={data} station={station?? {}}/>
        </div>
        <div>
            <MDTypography variant="h5">{t('tempGraph.title')}</MDTypography>
            <TempGraph data={data} station={station ?? {}}/>
        </div>
    </MDBox>
}

export default StationGraphs;